/** @format */

import { ExternalLink, InternalLink, Modal } from '@/types/page';
import { Options } from '@contentful/rich-text-react-renderer';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import { Entry } from 'contentful';
import { ReactNode } from 'react';
import { MagicLink } from 'src/utils/magicLink';
import LinkedIn from '../../assets/icons/icon_linkedin_filled.svg';
import { Icon } from '../ui/Icon';
import { RichText } from '../ui/RichText';
import { H2, H3, P, Subtitle } from '../ui/Typography';
import { WrapperScroll } from './Modal.style';

const ModalContent = ({ modal, donutType, isMain }: ModalContentProps): JSX.Element => {
  return (
    <>
      <H3>{modal.title}</H3>
      {modal.type === 'leadership' && (
        <P>
          {donutType === 'dv-holding'
            ? modal.dvHoldingRole
            : isMain
            ? modal.role
            : modal.governanceRole ?? modal.role ?? ''}
        </P>
      )}
      <WrapperScroll>
        <RichText text={modal.body} customOptions={options} />
      </WrapperScroll>
    </>
  );
};

export interface ModalContentProps {
  modal: Modal;
  donutType?: 'joivy' | 'dv-holding';
  isMain?: boolean;
}
const options: Options = {
  renderMark: {
    [MARKS.ITALIC]: (text: ReactNode) => <em>{text}</em>,
  },
  renderNode: {
    [BLOCKS.HEADING_2]: (node, children) => <H2>{children}</H2>,
    [BLOCKS.HEADING_3]: (node, children) => <H3>{children}</H3>,
    [BLOCKS.HEADING_4]: (node, children) => <Subtitle as={'h4'}>{children}</Subtitle>,
    [BLOCKS.HEADING_6]: (node, children) => <Subtitle>{children}</Subtitle>,
    [BLOCKS.PARAGRAPH]: (node, children) => {
      // to avoid rendering empty paragraphs
      if (Array.isArray(children) && children.length === 1 && children[0] === '') return;
      return <P>{children}</P>;
    },
    [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
      if (
        node.data.target.sys.contentType.sys.id === 'internalLink' ||
        node.data.target.sys.contentType.sys.id === 'externalLink' ||
        node.data.target.sys.contentType.sys.id === 'link'
      ) {
        const item: Entry<InternalLink['fields'] | ExternalLink['fields']> = node.data.target;
        return (
          <MagicLink item={item}>
            <Icon icon={LinkedIn} width={33} height={33} />
          </MagicLink>
        );
      }
    },
  },
};

export default ModalContent;
